export default __webpack_public_path__ + "static/GI-adverse-events-sm@2x-5bb3f6615d289134e97062e736fca952.png";